import { render, staticRenderFns } from "./CTNotReading.AU.4.vue?vue&type=template&id=2c3b97eb&scoped=true"
import script from "./CTNotReading.AU.4.vue?vue&type=script&lang=js"
export * from "./CTNotReading.AU.4.vue?vue&type=script&lang=js"
import style0 from "./CTNotReading.AU.4.vue?vue&type=style&index=0&id=2c3b97eb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3b97eb",
  null
  
)

export default component.exports